import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ParentComponentApi} from '../../profile/profile.component';
import {DxFormComponent} from 'devextreme-angular';
import { BankdetailsformService,BankDetails } from '../../../services/bankdetailsform.service';  
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../../app.constants';
import {HelperService} from '../../../../shared/services/helper.service';
import { compilePipeFromMetadata } from '@angular/compiler';

@Component({
  selector: 'tenthcetmark',
  templateUrl: './tenthcetmark.component.html',
  styleUrls: ['./tenthcetmark.component.scss'],
  providers:[BankdetailsformService,HelperService]
})
export class TenthcetmarkComponent implements OnInit {

  @ViewChild(DxFormComponent) bankdetailsForm: DxFormComponent;
  @ViewChild(DxFormComponent) myform: DxFormComponent;
  readOnly: boolean = false;
  isValid: boolean;
  SaveBtnDisabled: boolean;
  bankDetailsData:BankDetails;
  errorMessage: string[] = new Array(); 
  dataSource:any;
  LanguageLabel:any;
  namePattern: any = /^[^0-9]+$/;
  NomineeRelation:string;
  documentId: number;
  urlDoc: string;
  TenthCETMarkDocPath:string;
  popupVisible: boolean;
  popupTitle: string;
  public TenDocFile: string;
  NomineeRelationSource: any = [
    { NomineeRelation : 'Father',NomineeRelationName : 'Father' },
    { NomineeRelation : 'Mother',NomineeRelationName : 'Mother' },
    { NomineeRelation : 'Brother',NomineeRelationName : 'Brother' },
    { NomineeRelation : 'Sister',NomineeRelationName : 'Sister' },
    { NomineeRelation : 'Uncle',NomineeRelationName : 'Uncle' },
    { NomineeRelation : 'GrandMother',NomineeRelationName : 'GrandMother' },
    { NomineeRelation : 'GrandFather',NomineeRelationName : 'GrandFather' },
  ];
  Pattern1: any =/^[^<>]+$/;
  constructor(private http:HttpClient,
    private router: Router,private route: ActivatedRoute,private bankdetailsformService:BankdetailsformService, private configuration: Configuration,private helperService:HelperService) { }

  ngOnInit() 
  {
     this.clearData();
    this.GetBankDetail();
    this.LanguageLabel =this.configuration.LanguageLabel[0];
  }
  GetBankDetail()
  {
    this.bankdetailsformService.GetTenthCETMarkDetail( this.bankDetailsData.StudentID)
    .subscribe((data: BankDetails[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => {
        this.bankDetailsData.TenthCETMark=this.dataSource[0].TenthCETMark;
        this.TenthCETMarkDocPath=this.dataSource[0].TenthCETMarkDocPath;
      }); 
  }

  cancelClick(){
    this.SaveBtnDisabled = false;
    this.errorMessage=[];
    this.router.navigate(['/login-form']);
  }
  saveRecord() {
    if ((this.configuration.StudentID==null)||(this.configuration.StudentID==0))
    {
      this.helperService.showSuccessMessage("Blank Student Id Not Allowed.");
      return false;    
    }
    this.isValid = this.bankdetailsForm.instance.validate().isValid;
    if(this.isValid == true) { 
    if ((this.bankDetailsData.TenthCETMark==null)||(this.bankDetailsData.TenthCETMark==0))
    {
      this.helperService.showSuccessMessage("Enter CET Marks");
      this.bankDetailsData.IFSCCode="";
      return false;
    }
      this.errorMessage=[];
      debugger
      
         this.bankDetailsData.StudentID=this.configuration.StudentID;
        this.bankdetailsformService.updateTenthCETMark(this.bankDetailsData)
          .subscribe(value => {
           
            this.uploadFile();
          },
            err => {
              this.errorMessage=this.helperService.getErrorMessage(err);
              this.helperService.showSuccessMessage("Not Saved.");    
            },
            () => {
            
            });
    }
  }
  selectionChangedHandlerLocalState(e) {
    var NomineeRelation = e.value;
    if(NomineeRelation == null || NomineeRelation == undefined){
      return;
    }
    this.NomineeRelation=NomineeRelation;
  }
  clearData(){
    this.bankDetailsData={
      StudentID:this.configuration.StudentID,
      BankName :"",
      BankBranchName:"",
      IFSCCode:"",
      AccountNo: "",

      NomineeName: "",
      NomineeRelation: "",
      NomineeBirthDate:null,
      NomineeAge:0,
      NomineeGender:"",
      TenthCETMark:null,
      TenthCETMarkDocPath:null,
      }
      this.errorMessage=[];
  }
  onSuccessSave() {
    this.helperService.showSuccessMessage("Mark Saved Successfully.");    
    this.GetBankDetail();
     //this.clearData();
  }
  viewPdfDocument() {
    debugger
    if (this.TenthCETMarkDocPath!='') {
      this.urlDoc = this.TenthCETMarkDocPath ;
      this.openWindow();
    }
  }
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  uploadFile(){debugger
    if( this.configuration.UploadFile != undefined && this.configuration.UploadFile != null){
      this.bankdetailsformService.uploadDocFile(this.configuration.UploadFile, this.configuration.StudentID).subscribe(
        data => { 
          this.onSuccessSave();
        },
        err => {debugger; 
        },
        () => { 
        })  
      }
    }
    getdata() {    }
}

